<template>
  <common-template>
      <div class="list">
        <h1 class="title d-flex border-bottom inner">
          {{ $t(pageTitle) }}
        </h1>
        <div class="search inner">
          <div class="title accordion d-flex justify-content-between align-items-center" id="accordionDrawing-header" data-toggle="collapse" data-target=".accordionDrawing" aria-controls="searchContent searchButton">
            <h2>{{ $t("検索条件") }}</h2>
            <div class="accordion-toggle-btn">
              <b-button block id="accordionDrawing-up">{{ $t('閉じる') }}</b-button>
              <b-button block id="accordionDrawing-down">{{ $t('開く') }}</b-button>
            </div>
          </div>
          <div id="searchContent" class="accordionDrawing content collapse" aria-labelledby="accordionDrawing-header">
            <div class="d-flex flex-row flex-wrap">
              <div
                class="m-3 d-flex flex-row align-items-center justify-content-start form-group"
              >
                <label for="search-status" class="label">{{ $t('品番') }}:&nbsp;</label>
                <!-- <input v-model="search.code" type="text" class="input -small form-control"> -->
                <vue-simple-suggest
                  :list="getSuggestListForProductCode"
                  v-model="search.code"
                  :debounce="250"
                >
                </vue-simple-suggest>
              </div>
              <div
                class="m-3 d-flex flex-row align-items-center justify-content-start form-group"
              >
                <label for="search-status" class="label">{{ $t('品名') }}:&nbsp;</label>
                <!-- <input v-model="search.name" type="text" class="input -small form-control"> -->
                <vue-simple-suggest
                  :list="getSuggestListForProductName"
                  v-model="search.name"
                  :debounce="250"
                >
                </vue-simple-suggest>
              </div>
              <div
                class="m-3 d-flex flex-row align-items-center justify-content-start form-group"
              >
                <label for="search-status" class="label"
                  >{{ $t('図番') }}:&nbsp;</label
                >
                <input type="text" v-model="search.figureNo" class="input -small form-control">
              </div>
              <div
                class="m-3 d-flex flex-row align-items-center justify-content-start form-group"
              >
                <label for="search-status" class="label"
                  >{{ $t('備考') }}:&nbsp;</label
                >
                <input type="text" v-model="search.note" class="input -small form-control">
              </div>
            </div>
            <div class="d-flex flex-row flex-wrap">
                <div class="m-3 d-flex flex-row align-items-center justify-content-start form-group">
                    <label class="label">{{ $t("登録日") }}:&nbsp;</label>
                    <div class="row">
                      <div class="col-md-12">
                        <date-picker v-model="search.registerDateFrom" :config="datepicker.options" class="calendar"></date-picker>
                      </div>
                    </div>
                    <span class="m-1">~</span>
                    <div class="row">
                      <div class="col-md-12">
                        <date-picker v-model="search.registerDateTo" :config="datepicker.options" class="calendar"></date-picker>
                      </div>
                    </div>
                </div>
                <div class="m-3 d-flex flex-row align-items-center justify-content-start form-group">
                    <input v-model="search.type" type="checkbox" id="search10" class="checkbox form-control" value="ownbrand"><label class="label" for="search10">{{ $t("内製品") }}</label>
                    <input v-model="search.type" type="checkbox" id="search11" class="checkbox form-control" value="purchase"><label class="label" for="search11">{{ $t("仕入品") }}</label>
                    <input v-model="search.type" type="checkbox" id="search12" class="checkbox form-control" value="material"><label class="label" for="search12">{{ $t("材料") }}</label>
                </div>
            </div>
          </div>
          <div id="searchButton" class="button accordionDrawing collapse">
            <button class="btn btn-info" @click="searchMet(true)">
              {{ $t('検索') }}
            </button>
          </div>
        </div>
        <div class="inner d-flex justify-content-between mt-4 mb-4">
          <div class="d-flex">
            <button
                type="button"
                class="btn btn-success create-btn mr-3"
                @click="locationCreate()"
            >
                {{ $t('登録') }}
            </button>
            <button
                type="button"
                class="btn btn-success create-btn mr-3"
                @click="csvModalOpen('product')"
                :disabled="isTrial"
            >
                {{ $t('製品データ取込') }}
            </button>
            <button
                type="button"
                class="btn btn-success create-btn"
                @click="csvModalOpen('productProcess')"
                :disabled="isTrial"
            >
                {{ $t('製品工程データ取込') }}
            </button>
          </div>
          <select
            class="input input-sm display-number form-control custom-select"
            v-model="mixinParPage"
            @change="handleLimitChange()"
          >
            <option value="10">{{ $t('10行') }}</option>
            <option value="30">{{ $t('30行') }}</option>
            <option value="50">{{ $t('50行') }}</option>
            <option value="100">{{ $t('100行') }}</option>
          </select>
        </div>
        <div class="table-list inner">
          <h2 class="title">{{ $t('検索結果') }}</h2>
          <div class="content">
            <table class="table table-bordered table-hover">
              <thead class="thead">
                <tr>
                  <th width="25"><input @click="checkProductAll()" type="checkbox" class="checkbox" id="product-all"></th>
                  <th width="130" scope="col" id="type" @click="mixinSearchWordSort('type')">
                    <font-awesome-icon :icon="['fas', 'sort-alpha-down']" :class="'ascending sort-icon mr-2'" />
                    <font-awesome-icon :icon="['fas', 'sort-alpha-down-alt']" :class="'descending sort-icon mr-2'" />
                    {{ $t('種別') }}</th>
                  <th width="180" scope="col" id="code" @click="mixinSearchWordSort('code')">
                    <font-awesome-icon :icon="['fas', 'sort-alpha-down']" :class="'ascending sort-icon mr-2'" />
                    <font-awesome-icon :icon="['fas', 'sort-alpha-down-alt']" :class="'descending sort-icon mr-2'" />
                    {{ $t('品番') }}</th>
                  <th width="130" scope="col" id="version" @click="mixinSearchWordSort('version')">
                    <font-awesome-icon :icon="['fas', 'sort-alpha-down']" :class="'ascending sort-icon mr-2'" />
                    <font-awesome-icon :icon="['fas', 'sort-alpha-down-alt']" :class="'descending sort-icon mr-2'" />
                    {{ $t('改訂') }}</th>
                  <th width="180" scope="col" id="name" @click="mixinSearchWordSort('name')">
                    <font-awesome-icon :icon="['fas', 'sort-alpha-down']" :class="'ascending sort-icon mr-2'" />
                    <font-awesome-icon :icon="['fas', 'sort-alpha-down-alt']" :class="'descending sort-icon mr-2'" />
                    {{ $t('品名') }}</th>
                  <th width="230" scope="col">{{ $t('備考') }}</th>
                  <th width="130" scope="col" id="" @click="mixinSearchWordSort('registerDate')">
                    <font-awesome-icon :icon="['fas', 'sort-alpha-down']" :class="'ascending sort-icon mr-2'" />
                    <font-awesome-icon :icon="['fas', 'sort-alpha-down-alt']" :class="'descending sort-icon mr-2'" />
                    {{ $t('登録日') }}</th>
                  <th width="100" scope="col"></th>
                  <th width="160" scope="col"></th>
                  <th width="90" scope="col"></th>
                </tr>
              </thead>
              <tbody class="tbody">
                <template v-if="!load && this.list.length">
                  <tr v-for="(item, index) in this.list" :key="index">
                    <td><input v-model="form.id" type="checkbox" :id="`product-${index}`" class="checkbox" :value="item.id"></td>
                    <td @click="checkProductItem(item, index)">
                      <template v-if="item.type === 'ownbrand'">
                        {{ $t('内製品') }}
                      </template>
                      <template v-else-if="item.type === 'purchase'">
                        {{ $t('仕入品') }}
                      </template>
                      <template v-if="item.type === 'material'">
                        {{ $t('材料') }}
                      </template>
                      <template v-if="item.type === 'progress'">
                        {{ $t('仕掛品') }}
                      </template>
                    </td>
                    <td @click="checkProductItem(item, index)">{{ item.code }}</td>
                    <td @click="checkProductItem(item, index)">{{ item.version }}</td>
                    <td @click="checkProductItem(item, index)">{{ item.name }}</td>
                    <!-- <td @click="checkProductItem(item, index)">{{ item.figureNo }}</td> -->
                    <td @click="checkProductItem(item, index)" class="text-break">{{ item.note }}</td>
                    <td @click="checkProductItem(item, index)">{{ item.registerDate | mixinDateShortFormat }}</td>
                    <td>
                      <button
                        type="button"
                        class="btn-light btn"
                        @click="detailLink(item)"
                      >
                        {{ $t('詳細') }}
                      </button>
                    </td>
                    <td>
                      <button
                        type="button"
                        class="btn-light btn"
                        @click="constitutionLink(item)"
                      >
                        {{ $t('構成部品表') }}
                      </button>
                    </td>
                    <td>
                      <button
                        type="button"
                        class="btn-danger btn"
                        @click="deleteAlert(item)"
                      >
                        {{ $t('削除') }}
                      </button>
                    </td>
                  </tr>
                </template>
                <template v-else-if="!load && !this.list.length">
                  <tr>
                    <td rowspan="2" colspan="99" class="text-center">
                      {{ $t('ノーデータメッセージ') }}
                    </td>
                  </tr>
                </template>
                <template v-else-if="load">
                  <tr>
                    <td colspan="12">
                      <div
                        class="d-flex justify-content-center m-5"
                        v-if="load"
                      >
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
        <div class=" inner d-flex justify-content-between">
          <button
                type="button"
                class="btn btn-danger mt-3"
                @click="batchDeleteAlert()"
            >
                {{ $t('一括削除') }}
            </button>
          <paginate
            :page-count="mixinGetPageCount"
            :force-page="mixinGetForcePage"
            :page-range="3"
            :margin-pages="1"
            :click-handler="handlePageChange"
            :prev-text="'«'"
            :next-text="'»'"
            :container-class="'pagination justify-content-end mt-3 mr-0'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :prev-class="'page-item'"
            :prev-link-class="'page-link'"
            :next-class="'page-item'"
            :next-link-class="'page-link'"
            ref="page"
          >
          </paginate>
        </div>
        <csv-modal
        ref="csv"
        ></csv-modal>
      </div>
  </common-template>
</template>

<script>
import { mapGetters } from 'vuex'
import Api from '../../mixin/api'
import searchHelper from '../../mixin/search-helper'
import csvModal from './csvModal'


export default {
  mixins: [searchHelper, Api],
  data() {
    return {
      date: new Date(),
      list: [],
      search: {
        code: '',
        name: '',
        figureNo: '',
        note: '',
        registerDateFrom: '',
        registerDateTo: '',
        type: ['ownbrand', 'purchase'],
      },
      form: {
        id: [],
      },
      load: false,
      master: {},
      pageTitle: '製品情報一覧',
    }
  },
  components: {
    csvModal,
  },
  updated() {
    document.title = this.$t(this.pageTitle)
  },
  async created() {
    this.load = true

    // masterから一括でデータを取得
    const masterData = await this.$axios.get(
      `${this.$appConfig.CommonApiUrl}/masters`,
      {
        headers: {
          Authorization: this.authorization ? this.authorization : null,
        },
      }
    )
    if (masterData) this.master = masterData.data

    const url = location.search
    const searchParams = new URLSearchParams(url)
    if (searchParams.get('code')) {
      this.search.code = searchParams.get('code')
    }
    try {
      await this.$store.dispatch('auth/user')
    } catch (err) {
      this.$toasted.show(err)
      this.$toasted.show('Userの取得でエラー')
    }
    await this.searchMet()
  },
  methods: {
    async handleLimitChange() {
      await this.searchMet(true)
    },
    async handlePageChange(pageNum) {
      this.mixinClickCallback(pageNum)
      this.searchMet()
    },
    async searchMet(resetPage = false) {
      try {
        this.load = true
        if (resetPage === true) this.mixinCurrentPageClear()
        if (this.list.length) this.checkProductAll(false)
        let params = {}
        for (let key of Object.keys(this.search)) {
          if (this.search[key]) params[key] = this.search[key]
        }
        if (params['type'].length) {
          params['type'] = params['type'].join(',')
        }
        this.list = await this.mixinGetPageList(
          `${this.$appConfig.CommonApiUrl}/products`,
          params,
          {},
        )
      } catch (err) {
        // this.$toasted.show(err)
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
      this.load = false
    //   this.checkProductAll(false)
    },
    // 検索結果の製品ごとにクリックするとcheckboxがDOM的に入れ替わる処理
    checkProductItem(item, index) {
      const checked = document.getElementById(`product-${index}`)
      const checkedAll = document.getElementById('product-all')
      const displayList = (Number(this.mixinParPage) > this.list.length) ? this.list.length : Number(this.mixinParPage)
      checked.checked = !checked.checked
      if (!checked.checked) {
        this.form.id = this.form.id.filter(id => id !== item.id)
      } else {
        this.form.id.push(item.id)
      }
      let active = 0
      for (let i = 0; i < displayList; i++) {
        const checked = document.getElementById(`product-${i}`)
        if (checked.checked) active++
      }
      checkedAll.checked = (active === displayList) ? true : false
    },
    // 全ての製品のcheckboxがDOM的に入れ替わる処理
    checkProductAll(status = true) {
      const checkedAll = document.getElementById('product-all')
      if (!this.list.length) return
      if (!status) checkedAll.checked = false
      const displayList = (Number(this.mixinParPage) > this.list.length) ? this.list.length : Number(this.mixinParPage)
      this.form.id = []
      if (checkedAll.checked && status) {
        for (let i = 0; i < displayList; i++) {
          const checked = document.getElementById(`product-${i}`)
          checked.checked = true
          this.form.id.push(Number(checked.value))
        }
      } else {
        for (let i = 0; i < displayList; i++) {
          const checked = document.getElementById(`product-${i}`)
          if (checked)
            checked.checked = false
        }
      }
    },
    // 登録画面に遷移
    locationCreate() {
      window.location = process.env.NODE_ENV !== 'development' ? '/base/product/create.html' : '/product/create.html'
    },
    // 製品データ取込のモーダルを開いたときの処理
    csvModalOpen(type) {
      this.$refs.csv.modalOpen(type)
    },
    // 一括削除
    async batchDeleteAlert() {
      if (this.form.id === null || this.form.id.length === 0) {
        await this.$swal({
          text: this.$t('削除する製品を選択して下さい'),
          className: 'swal-none',
          // icon: 'warning',
          buttons: {
            confirm: {
              text: 'OK',
              value: true,
              visible: true,
              className: 'btn-light',
              closeModal: false,
            },
          },
          dangerMode: false,
        })
        this.$swal.close()
        return
      }
      const confirm = await this.$swal({
        text: this.$t('一括削除確認メッセージ'),
        className: 'swal-none',
        // icon: 'warning',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: 'btn-light',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: 'btn-danger',
            closeModal: false,
          },
        },
      })
      if (confirm) {
        try {
          await this.$axios.post(
            `${this.$appConfig.CommonApiUrl}/product/bulk/delete`,
            {
              ids: this.form.id,
            },
            {
              headers: {
                Authorization: this.authorization
                ? this.authorization : null,
              },
            },
          )
          this.$swal.close()
          this.$toasted.success(this.$t('一括データ削除完了メッセージ'))
          await this.searchMet()
          // this.$swal(this.$t('一括データ削除完了メッセージ'), {
          //   icon: 'success',
          //   timer: 2000,
          // })
        } catch (err) {
          this.$toasted.show(err)
          this.$toasted.show('削除に失敗しました')
        }
      }
    },
    // 削除処理
    async deleteAlert(item) {
      const confirm = await this.$swal({
        text: this.$t(`${item.code}`) + this.$t('削除確認メッセージ'),
        className: 'swal-none',
        // icon: 'warning',
        buttons: {
          cancel: {
            text: this.$t('キャンセル'),
            value: null,
            visible: true,
            className: 'btn-light',
            closeModal: true,
          },
          confirm: {
            text: 'OK',
            value: true,
            visible: true,
            className: 'btn-danger',
            closeModal: false,
          },
        },
        dangerMode: true,
      })
      if (confirm) {
        try {
          await this.$axios.delete(
            `${this.$appConfig.CommonApiUrl}/product`,
            {
              headers: {
                Authorization: this.authorization ? this.authorization : null,
              },
              params: { id: item.id },
            }
          )
          this.$swal.close()
          this.$toasted.success(this.$t('データ削除完了メッセージ'))
          // this.$swal(this.$t('データ削除完了メッセージ'), {
          //   icon: 'success',
          //   timer: 2000,
          // })
        } catch (err) {
          this.$toasted.show(err)
          this.$toasted.show('削除に失敗しました')
        }
        await this.searchMet()
      }
    },
    detailLink(item) {
      let params = {}
      params.id = item.id
      window.location.href = process.env.NODE_ENV !== 'development' ? `/base/product/detail.html?${this.mixinGetUrlParams(params)}` : `/product/detail.html?${this.mixinGetUrlParams(params)}`
    },
    constitutionLink(item) {
      let params = {}
      params.productId = item.id
      window.location.href = process.env.NODE_ENV !== 'development' ? `/base/constitution/index.html?${this.mixinGetUrlParams(params)}` : `/constitution/index.html?${this.mixinGetUrlParams(params)}`
    },
    getSuggestListForProductCode: async function(newVal) {
      const params = {code: newVal}
      const res = await this.mixinGetAPI(
          `${this.$appConfig.CommonApiUrl}/products`,
          params,
        )
      if (!res) return []
      return res.map(item => item.code)
    },
    getSuggestListForProductName: async function(newVal) {
      const params = {name: newVal}
      const res = await this.mixinGetAPI(
          `${this.$appConfig.CommonApiUrl}/products`,
          params,
        )
      if (!res) return []
      return res.map(item => item.name)
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
      userdata: 'auth/userdata',
    }),
    isTrial() {
      if (this.master.hasOwnProperty('company') && this.master.company) {
        if (this.master.company.hasOwnProperty('isTrial')) {
          return this.master.company.isTrial
        }
      }
      return false
    },
  },
}
</script>

<style lang="scss">
  .vue-simple-suggest.designed .input-wrapper input{
    padding:.375rem .75rem !important;
  }
</style>
<style lang="scss" scoped>
  td{
      word-break: break-all;
  }
</style>
